module.exports = __webpack_public_path__ + "static/media/map-marker-alt-slash.81f91c7c.svg";